import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
    UpCircleOutlined,
    RedoOutlined,
    UnorderedListOutlined
} from "@ant-design/icons";
import './GptTemplate.scss';
import { Content } from "antd/es/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Input, TreeSelect, message, Tooltip } from "antd";
import Modal from "antd/es/modal/Modal";
import HandAnimatedIcon from "../../assets/images/icons/animated_hand.gif";
import { search } from "fast-fuzzy";
import { toggleTour } from "../../reducers/tourSlice";
import ChatSection from "../../components/ChatSection";
import PageTour from "../../components/PageTour/PageTour";
import ChatAnimationImage from "../../assets/images/icons/chat_circle.gif";
import { setChatBotTemplatePage } from "../../reducers/ChatBotTemplateSlice";
import { uploadFolderModalAPI } from "../../apis"
import DropdownFileItem from "../../components/DropdownFileItem";
import UploadFolderModal from "../../components/UploadFolderModal";
import ReactQuill from 'react-quill';
import { togglePrompt, showSidebarPrompt } from "../../reducers/promptSlice";
import PromptLibrary from "../prompt-library/PromptLibrary";
import { Auth } from '../../libs/utilities/helpers/Auth';
import { getTitleFromPath } from "../../libs/utilities/helpers/getTitle"
const GptTemplate = ({ serviceName, feature, title, serviceId }) => {

    const [tourStep, setTourStep] = useState(0);
    const [userInput, setUserInput] = useState("");
    const [showHandAnimation, setShowHandAnimation] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [chatLoad, setChatLoad] = useState(false);
    const [inputValue, setInputValue] = useState("");
    const [treeData, setTreeData] = useState([]);
    const [folderList, setFolderList] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(false);
    const [selectedFile, setSelectedFile] = useState([]);
    const [dialogData, setDialogData] = useState();
    const [showDialog, setShowDialog] = useState(false);
    const [deletionLoading, setDeleteLoading] = useState(false);
    const [isPageUpdated, setIsPageUpdated] = useState(false);
    const [totalFileCount, setTotalFileCount] = useState(0);
    const [prompt, setPrompt] = useState('');
    const [suggestionList, setSuggestionList] = useState([]);
    const [departmentList, setDepartmentList] = useState([]);
    const suggestionTimeoutRef = useRef(null);
    const chatBotPage = useSelector((state) => state.chatBotTemplate.currentPage);
    const showPrompt = useSelector((state) => state.prompt).show;
    const location = useLocation();
    const dispatch = useDispatch();
    const chatInput = document.getElementsByClassName("chat-input");
    const tourState = useSelector((state) => state.tour);
    const chatContentRef = useRef(null);
    const quillRef = useRef(null);
    let showUserInput = true;
    const user = Auth.getUser();
    const showSidebarPromptvalue = useSelector((state) => state.prompt).promptSidebarShow;
    const promptSelected = useSelector((state) => state.prompt).show;

    //useEffect for handell the prompt library show in sidebar section handel redux state
    useEffect(() => {
        if (feature.promptLibrary) {
            dispatch(showSidebarPrompt({ promptSidebarShow: true }))
        } else {
            dispatch(showSidebarPrompt({ promptSidebarShow: false }))
        }
    }, [])

    //useEffect for set the page name like servicename
    useEffect(() => {
        const page = serviceName;
        dispatch(setChatBotTemplatePage(page));
        setIsPageUpdated(true)
    }, [dispatch]);

    //useEffect for the showing the showPrompt to when click on prompt in sidebar 
    useEffect(() => {
        if (showPrompt)
            setPrompt('');
    }, [showPrompt])

    //useEffect for the take a tour show
    useEffect(() => {
        let timeout;
        if (tourState.show) {
            timeout = setTimeout(() => {
                setShowHandAnimation(true);
            }, 1000);
        } else {
            setShowHandAnimation(false);
        }
        return () => {
            clearTimeout(timeout);
        };
    }, [tourState]);

    //useEffect for set the fileCount based on that show the welcome message text of file upload
    useEffect(() => {
        let totalCount = 0;
        folderList.forEach(item => {
            totalCount += item.file.length;
        })
        setTotalFileCount(totalCount);
    }, [folderList])

    //useEffect for the if page is update call the file list api to fetch the files
    useEffect(() => {
        if (isPageUpdated && chatBotPage) {
            getFileList();
        }
    }, [chatBotPage, isPageUpdated]);

    //useEffect for the set the prompt message when click on selected prompt via prompt library
    useEffect(() => {
        setUserInput(prompt);
    }, [prompt]);

    const getPrompt = (value) => {
        setPrompt(value.query)
        dispatch(togglePrompt({ show: false }))
    }

    const handleTourClose = () => {
        dispatch(toggleTour({ show: false }))
    }

    const handleInputChange = async (value) => {
        if (showUserInput) {
            setUserInput(value);
            // setUserInput(quillRef.current.input.value);
            const strippedText = new DOMParser().parseFromString(value, 'text/html').body.textContent.trim().toLowerCase();
            // Split input into words
            const words = strippedText.split(/\s+/);
            if (feature.suggestion) {
                const stopWord = ['what', 'when', 'who', 'whom', 'why', 'how', 'is', 'am', 'are', 'was', 'were', 'will', 'shall', 'can', 'may', 'could', 'would', 'should', 'might', 'at', 'on', 'of', 'in', 'for', 'from', 'above', 'below', 'the', 'you', 'applicable', '?', '!', '.'];
                let wordMatchFlag = false;
                let matches = [];

                for (let i = words.length - 1; i >= 0; i--) {
                    const normalizedWord = words[i].toLowerCase();
                    if (!stopWord.includes(normalizedWord) && !wordMatchFlag) {
                        matches = search(normalizedWord, suggestionList);
                        wordMatchFlag = true;
                    }
                }

                setSuggestions(matches);
                // If suggestions are shown, set a timeout to hide them after 6 seconds
                if (matches.length > 0) {
                    // Clear any existing timeout
                    if (suggestionTimeoutRef.current) {
                        clearTimeout(suggestionTimeoutRef.current);
                    }
                    // Set a new timeout to hide suggestions after 6 seconds
                    suggestionTimeoutRef.current = setTimeout(() => {
                        setSuggestions([]);  // Clear the suggestions after 6 seconds
                    }, 10000);
                }
            }
        } else {
            showUserInput = true;
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            if (userInput.trim() !== "") {
                handleChatSubmit(userInput);
            }
        }
    };

    const handleChatInputClick = () => {
        dispatch(toggleTour({ show: false }))
        setShowHandAnimation(false);
        chatInput[0].style.zIndex = "inherit";
        const timeout = setTimeout(() => {
            setTourStep(0);
            clearTimeout(timeout);
        }, 500);
    };

    const openConfirmatinDialog = (data) => {
        setDialogData(data);
        setShowDialog(true);
    }

    const toggleModalVisibility = () => {
        setIsModalVisible(!isModalVisible);
    };

    const showModal = () => {
        setIsModalVisible(true);
    };

    const onChange = (value) => {
        setSelectedFile(value);
    };

    const handleSuggestionClick = (suggestion) => {
        const quill = quillRef.current ?.getEditor();
        if (!quill) {
            console.error("Quill editor ref not ready");
            return;
        }
        quill.focus();
        let selection = quill.getSelection();
        if (!selection) {
            const length = quill.getLength();
            quill.setSelection(length, length);
            selection = { index: length, length: 0 };
        }
        const cursorPos = selection.index;
        // Get text before cursor
        const fullText = quill.getText();
        const beforeCursor = fullText.slice(0, cursorPos);
        // Find last word before cursor
        const match = beforeCursor.match(/(?:\s|^)([^\s]*)$/);
        const word = match ? match[1] : "";
        const wordStart = match ? cursorPos - word.length : cursorPos;
        // Replace word
        quill.deleteText(wordStart, word.length);
        quill.insertText(wordStart, suggestion + " ");
        // Move cursor to end
        setTimeout(() => {
            const length = quill.getLength();
            quill.focus();
            quill.setSelection(length, length);
        }, 0);
        setUserInput(quill.root.innerHTML);
        setSuggestions([]);
        showUserInput = false;
        // Hide suggestions after 6 seconds
        setTimeout(() => {
            setSuggestions([]);
        }, 6000);
    };

    const handleGetListRefresh = () => {
        getFileList();
    }

    const handleRefresh = () => {
        setUserInput('');
        setSuggestions([]);
        setChatLoad(false);
        // Scroll to top of the chat content
        if (chatContentRef.current) {
            chatContentRef.current.scrollTo({
                top: 0,
                behavior: "smooth",  // Smooth scrolling to the top
            });
        }
        // Show success message
        message.destroy();
        message.success('Chat cleared');
    };

    const handleChatSubmit = (value) => {
        message.destroy();
        if (feature ?.suggestionMandatory && feature ?.suggestion) {
            const selectedMessage = value.trim().toLowerCase();
            const matches = suggestionList.find(item =>
                selectedMessage.includes(item.toLowerCase())
            );
            if (matches == undefined) {
                message.error("Kindly choose an option from the suggestion list to include in the prompt.");
                return;
            }
        }
        setInputValue(value);
        setChatLoad(true);
        setUserInput("");
    }

    const getFileList = () => {
        // Fetching folders and files
        try {
            dispatch(uploadFolderModalAPI.getPdfList({ serviceId })).then((response) => {
                if (response.meta ?.requestStatus === "fulfilled") {
                    const { filteredData, suggestionList, departmentList } = response.payload;
                    setSuggestionList(suggestionList)
                    let data = filteredData.map((item, index) => {
                        let data = {
                            title: <DropdownFileItem folder={item} file="" itemType="folder" confirmDelete={(data) => openConfirmatinDialog(data)} />,
                            value: item.folder_id,
                            key: item.folder_id,
                            children: item.file.map((file, count) => {
                                return {
                                    title: <DropdownFileItem folder={item} file={file} itemType="file" confirmDelete={(data) => openConfirmatinDialog(data)} />,
                                    value: file.id,
                                    key: file.id
                                }
                            })
                        };
                        return data;
                    })
                    setTreeData(data.filter(item => item.children.length > 0))
                    setFolderList(filteredData);
                    if (feature.departmentFolderAccess) {
                        setDepartmentList(departmentList);
                    }
                }
            });
        } catch (error) {
            // error
        }
    }

    const handleDeleteConfirmation = async () => {
        let params;
        if (dialogData.type === "folder") {
            let folder_id = dialogData.data.folder_id;
            let file_list = dialogData.data.file.map(file => file.id);
            params = {
                type: "folder",
                file_list: file_list,
                folder_id: folder_id
            };
        } else {
            let folder_id = dialogData.data.folder.folder_id;
            let file_id = dialogData.data.file.id;
            params = {
                type: "file",
                file_list: file_id ? [file_id] : [],
                folder_id: folder_id,
            };
        }
        try {
            setDeleteLoading(true);
            const response = await dispatch(uploadFolderModalAPI.removePdf({ serviceId, ...params }));
            if (response.payload ?.statusCode === 201) {
                message.success(`${dialogData.type === "folder" ? "Folder" : "File"} deleted successfully.`);
                // ================ Managing Local State ============================ //
                if (dialogData.type === "folder") {
                    let tempData = treeData.filter(item => item.key != dialogData.data.folder_id);
                    setFolderList((prev) => {
                        return prev.filter(item => item.folder_id !== dialogData.data.folder_id);
                    })
                    setTreeData(tempData.filter(item => item.children.length > 0))
                    setShowDialog(false);
                } else {
                    let folder_id = dialogData.data.folder.folder_id;
                    let file_id = dialogData.data.file.id;

                    // Modifying the dropdown tree list
                    let tempData = [...treeData];
                    let obj = tempData.find(item => item.key === folder_id);
                    obj.children = obj.children.filter(item => item.key !== file_id);

                    let findIndex = tempData.findIndex(item => item.key === obj.key);
                    tempData[findIndex] = obj;

                    // modifying the folderList
                    const tempObj = { ...folderList.find(item => item.folder_id === folder_id) }
                    tempObj.file = tempObj.file.filter(item => item.id !== file_id);

                    const fileIndex = folderList.findIndex(item => item.folder_id === folder_id);
                    let updatedFolderList = [...folderList]
                    updatedFolderList[fileIndex] = tempObj;
                    setFolderList(updatedFolderList)
                    setTreeData(tempData.filter(item => item.children.length > 0))
                    setShowDialog(false);
                }
                setSelectedFile([])
                // ================== Eng of managing state ======================== //
            }
            setShowDialog(false);
            setDeleteLoading(false);
        } catch (error) {
            setDeleteLoading(false);
            setShowDialog(false);
        }
    }


    const renderWelcomeText = (text) => {
        if (!text) {
            return <p className="text5">I am waiting for a prompt</p>;
        }

        const parseFormatting = (line) => {
            return line.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).map((part, i) => {
                if (part.startsWith('**') && part.endsWith('**')) {
                    return <strong key={i}>{part.slice(2, -2)}</strong>;
                } else if (part.startsWith('*') && part.endsWith('*')) {
                    return <em key={i}>{part.slice(1, -1)}</em>;
                }
                return part;
            });
        };

        // Replace "/n" (your input) with actual newlines
        const fixedText = text.replace(/\/n/g, '\n');
        const lines = fixedText.split('\n').filter(Boolean);

        return (
            <>
                {lines.length > 0 && <p className="text5">{parseFormatting(lines[0])}</p>}

                {lines.slice(1).map((line, idx) => {
                    const boldParts = line.split('**').filter(Boolean);

                    if (boldParts.length > 1) {
                        return (
                            <p className="text7" key={idx}>
                                {parseFormatting(boldParts[0])}
                                <span className="text8">{parseFormatting(`**${boldParts[1]}**`)}</span>
                                {parseFormatting(boldParts.slice(2).join('**'))}
                            </p>
                        );
                    }

                    return <p className="text7" key={idx}>{parseFormatting(line)}</p>;
                })}
            </>
        );
    };

    const showPromptoption = () => {
        dispatch(togglePrompt({ show: true }));
        // setPromptVisible((prev)=>!prev)
    };

    return (
        <>
            <div className="heading-div">
                <p className="text5">
                    {getTitleFromPath(location ?.pathname)}
                </p>
                {showSidebarPromptvalue &&
                    <div className="card-container-gpt" >
                        
                        <button onClick={() => {
                            if (showPrompt) {
                                dispatch(togglePrompt({ show: false }))
                            } else {
                                showPromptoption();
                            }
                        }} className="btn-outlined">
                            <div className="btn-outlined-content">
                                <div className="text">{showPrompt ? `Back` : `Prompt Library`}</div>
                            </div>
                        </button>
                    </div>

                }
            </div>
            <PageTour
                show={tourState.show}
                handleShow={handleTourClose}
                target="chat-input"
                title="Start Typing Your Prompt To See The Magic" />

            {
                feature.uploadFile && !showPrompt && feature.uploadAccessRole.includes(user.Role) && (
                    feature.departmentUploadAccess.includes(user.Department) ||
                    feature.departmentUploadAccess.includes('all')
                ) &&
                <>
                    <div className="cards">
                        <Content className="content">
                            {<Card className="big-card" size="large">
                                <div className="select-boxes gpt-select-file-dropdown">
                                    <TreeSelect
                                        style={{ width: "100%" }}
                                        treeCheckable={true}
                                        value={selectedFile}
                                        dropdownStyle={{ zIndex: "999" }}
                                        virtual={false}
                                        treeData={treeData}
                                        placeholder="Select Folder/File"
                                        allowClear
                                        showSearch={false}
                                        variant="borderless"
                                        treeDefaultExpandAll
                                        onChange={onChange}
                                        onClick={() => { setOpenDropdown((prev) => !prev) }}
                                        onBlur={() => { setOpenDropdown(false) }}
                                    />
                                </div>
                                <div className="card-uploadbutton">
                                    <div className="btn-wrapper">
                                        <Button type="primary2" id="upload-documents" onClick={showModal}>
                                            Upload Documents <UpCircleOutlined />
                                        </Button>
                                    </div>
                                </div>
                            </Card>}

                            {/* Modal for Upload */}
                            <div>
                                <UploadFolderModal
                                    showModal={isModalVisible}
                                    toggleModalVisibility={toggleModalVisibility}
                                    folderList={folderList}
                                    refreshFolderList={() => { handleGetListRefresh() }}
                                    feature={feature}
                                    departmentList={departmentList}
                                    serviceId={serviceId}
                                />
                            </div>
                        </Content>
                    </div>
                </>
            }


            <>
                <>
                    {
                        feature.promptLibrary &&
                        <>
                            <PromptLibrary showPrompt={showPrompt} getPrompt={getPrompt} page='gpt' serviceId={serviceId} />
                        </>
                    }
                </>
                <div style={{ flex: 1, height: "100%", display: showPrompt ? "none" : "contents" }}>
                    <>
                        {chatLoad ? (
                            <ChatSection
                                selectedFile={selectedFile}
                                folderList={folderList}
                                inputValue={inputValue}
                                feature={feature}
                                setChatLoad={setChatLoad}
                                serviceId={serviceId}
                            />
                        ) :
                            (
                                <div style={styles.empty} ref={chatContentRef}>
                                    <img
                                        className="animation"
                                        src={ChatAnimationImage}
                                        alt="waiting-gif"
                                        width={100}
                                        height={100}
                                    />
                                    {
                                        feature.uploadFile && feature.uploadAccessRole.includes(user.Role) && (
                                            feature.departmentUploadAccess.includes(user.Department) ||
                                            feature.departmentUploadAccess.includes('all')
                                        ) ?
                                            <>
                                                <p className='text5'>
                                                    {totalFileCount === 0 ?
                                                        "Upload a document to let's get started" :
                                                        (selectedFile.length === 0 ? "Select or upload a new document and let's get started" : (feature ?.welcomeText ? <span>{feature.welcomeText}</span> : <span >I am waiting for a prompt</span>))}
                                                </p>
                                            </>
                                            :
                                            <>
                                                {/* <p className="text5">{feature.welcomeText || 'I am waiting for a prompt'}</p> */}
                                                {renderWelcomeText(feature.welcomeText)}
                                            </>
                                    }
                                </div>
                            )
                        }
                    </>
                    <>
                        <div className="chat-input" style={{ flexDirection: "column" }}>
                            <div className='chat-input-content'>
                                <div
                                    className="chat-input-container"
                                >
                                    <ReactQuill
                                        placeholder="Type your prompt..."
                                        ref={quillRef}
                                        className="quill-prompt-gpt-template"
                                        theme="bubble"
                                        modules={{ toolbar: false }}
                                        value={userInput}
                                        onChange={handleInputChange}
                                        onKeyDown={handleKeyPress}
                                        onFocus={handleChatInputClick}
                                        style={{
                                            flex: 1,
                                            padding: '10px 12px',
                                            minHeight: '38px',
                                        }}
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            right: '36px',
                                            height: '60%',
                                            width: '1px',
                                            backgroundColor: '#d9d9d9',
                                            top: '2px'
                                        }}
                                    />
                                    <Tooltip title="Clear Chat">
                                        <Button
                                            className="refresh-button-gpt-template"
                                            type="default"
                                            onClick={handleRefresh}
                                            style={{
                                                position: 'absolute',
                                                right: '5px',
                                                 top: '35%',
                                                transform: 'translateY(-50%)',
                                                backgroundColor: 'transparent',
                                                border: 'none',
                                                boxShadow: 'none',
                                                padding: 0,
                                                minWidth: 0,
                                                height: 'auto'
                                            }}
                                            icon={<RedoOutlined style={{ fontSize: '18px' }} />}
                                        />
                                    </Tooltip>

                                    {feature.suggestion &&
                                        <>
                                            {
                                                suggestions.length > 0 && userInput && (
                                                    <div style={styles.suggestionList}>
                                                        {suggestions.map((suggestion, index) => (
                                                            <div style={styles.suggestionListItem} key={index} onClick={() => handleSuggestionClick(suggestion)}>
                                                                {suggestion}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )
                                            }
                                        </>
                                    }
                                </div>
                                <Button
                                    className="chat-input-button"
                                    type="primary"
                                    onClick={() => handleChatSubmit(userInput)} // Always clickable
                                    // disabled={isWaiting || userInput.length === 0 || userInput.trim() === ""}
                                    disabled={userInput.length == 0 || userInput === "<p><br></p>"}
                                >
                                    Submit
                  </Button>
                            </div>
                            <div style={{ textAlign: "center", width: "100%", fontSize: "12px", paddingRight: "50px", marginTop: "3px" }}>
                                {feature ?.disclaimer}
                            </div>
                            {showHandAnimation && <div className="hand-animated" style={{ position: "absolute", zIndex: "10000", bottom: "-20px" }}>
                                <img src={HandAnimatedIcon} width={80} />
                            </div>}
                        </div>
                    </>
                </div>
            </>

            <Modal
                title={`Delete ${dialogData && (dialogData.type === "folder" ? 'Folder' : 'File')}`}
                open={showDialog}
                onOk={handleDeleteConfirmation}
                onCancel={() => { setShowDialog(false) }}
                confirmLoading={deletionLoading}
                closeIcon={null} // Remove the close icon
                footer={[
                    <Button key="cancel" type="text" onClick={() => setShowDialog(false)} disabled={deletionLoading}>
                        Cancel
          </Button>,
                    <Button key="okay" type="primary" onClick={handleDeleteConfirmation} disabled={deletionLoading}>
                        {deletionLoading ? "Loading..." : "Delete"}
                    </Button>,
                ]}
            >
                <p>Are you sure you want to delete this {dialogData && (dialogData.type === 'folder' ? "folder" : "file")}?</p>
            </Modal>
        </>
    );
};

export default GptTemplate;


const styles = {
    empty: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "100%",
        justifyContent: "center",
    },
    inputWrapper: {
        display: "flex",
        width: "100%",
        gap: "22px",
        height: "40px",
        position: "relative",
    },
    suggestionList: {
        position: "absolute",
        bottom: "50px",
        border: "1px solid #dddd",
        background: "#ffffff",
        width: "100%",
        maxHeight: "200px",
        overflowY: "auto",
        borderRadius: "7px",
    },
    suggestionListItem: {
        padding: "4px 15px",
        cursor: "pointer",
    },
};
